// i18next-extract-mark-ns-start LaRubrique
import React from 'react';
import styled from 'styled-components';
import { useTranslation } from 'gatsby-plugin-react-i18next';
import { Link } from '../../services/link';
import { getCategoryArticlePageUrl } from '../../Routes';
import { tabletThresholdPixels } from '../home/v4/styledComponents';
import chevron from '../../assets/order/V.svg';

type SubCategoryItem = {
    slug: string;
    name: string;
};

type SubCategory = {
    slug: string;
    name: string;
    items: SubCategoryItem[];
};
type Category = {
    slug: string;
    name: string;
    subCategories: SubCategory[];
};
type MainCategory = {
    slug: string;
    name: string;
    categories: Category[];
};

const ColumnLeftLinks = styled.div`
    display: flex;
    flex-direction: column;
    width: 300px;
    gap: 20px;
    @media (max-width: ${tabletThresholdPixels}) {
        width: 100%;
        gap: 10px;
        align-items: center;
    }
    `;

type LinkTextProps = {
    isSelected: boolean;
};

const LinkText = styled.div<LinkTextProps>`
    font-size: 20px;
    font-weight: 400;
    text-decoration: none;
    text-transform: uppercase;
    cursor: pointer;
    margin-bottom: 16px;
    ${({ isSelected }) => isSelected && 'font-weight: 700;'}
    @media (max-width: ${tabletThresholdPixels}) {
        font-size: 16px;
        color: ${({ isSelected }) => isSelected ? 'black' : 'grey'};
    }
`;

const LinkTextSubCat = styled.div<LinkTextProps>`
    font-size: 16px;
    font-weight: 300;
    text-decoration: none;
    text-transform: uppercase;
    cursor: pointer;
    ${({ isSelected }) => isSelected && 'font-weight: 700;'}
    @media (max-width: ${tabletThresholdPixels}) {
        font-size: 16px;
        color: ${({ isSelected }) => isSelected ? 'black' : 'grey'};
    }
`;

const SubCategoriesContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: 10px;
    margin-left: 20px;
    @media (max-width: ${tabletThresholdPixels}) {
        margin-left: 10px;
    }
`;
interface ChevronProps {
    isSelected: boolean;
}
const Chevron = styled.img<ChevronProps>`
    width: 20px;
    height: 20px;
    margin-bottom: 16px;
    ${({ isSelected }) => isSelected ? 'transform: rotate(0);' : 'transform: rotate(180deg);'}
`;

const MainCategoryLink = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
`;
function BlogVerticalNavbar({
  mainCategory, category, subCategoryItem,
} : { mainCategory: MainCategory, category: Category, subCategoryItem: SubCategoryItem}) {
  const { t } = useTranslation();
  return (
    <div>
      {mainCategory?.categories ? (
        <ColumnLeftLinks>
          {mainCategory.categories.map((cat) => {
            const routeSlug = mainCategory.slug + cat.slug;
            return (
              <div key={cat.name}>
                <Link
                  to={getCategoryArticlePageUrl(routeSlug, 1)}
                  style={{ textDecoration: 'none', color: 'inherit' }}
                >
                  <MainCategoryLink>
                    <LinkText isSelected={cat.slug === category?.slug}>{t(cat.name)}</LinkText>
                    {!!cat.subCategories && <Chevron src={chevron} alt={`ouvrir ${cat.name}`} isSelected={cat.slug === category?.slug} />}
                  </MainCategoryLink>
                </Link>
                { cat.slug === category?.slug && !!cat.subCategories
                  ? (
                    <SubCategoriesContainer>
                      {
                        cat.subCategories.map((subCat) => (
                          subCat.items?.map((subCatItem) => {
                            const routeSubCatSlug = routeSlug + subCat.slug + subCatItem.slug;
                            return (
                              <div key={subCatItem.name}>
                                <Link to={getCategoryArticlePageUrl(routeSubCatSlug, 1)} style={{ textDecoration: 'none', color: 'inherit' }}>
                                  <LinkTextSubCat isSelected={subCatItem.slug === subCategoryItem?.slug}>{t(subCatItem.name)}</LinkTextSubCat>
                                </Link>
                              </div>
                            );
                          })))
                      }
                    </SubCategoriesContainer>
                  )
                  : null}
              </div>
            );
          })}
        </ColumnLeftLinks>
      ) : null}
    </div>
  );
}

export default BlogVerticalNavbar;
